import styled from "@emotion/styled"
import { Link } from "gatsby"

export const MainContainer = styled.div`
  justify-content: space-between;
  margin-top: ${props => props.marginTop};
  margin-inline: 0px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    border: ${props =>
      props.status === "cancelled" || props.status === "postponed"
        ? "1px solid #F62F2F"
        : "none"};
    border-radius: 8px;
    position: relative;
  }
`
export const MobileMainContainer = styled.div`
  justify-content: space-between;
  margin-top: 16px;
  margin-inline: 0px;
  position: relative;
  border: ${props =>
    props.status === "cancelled" || props.status === "postponed"
      ? "1px solid #F62F2F"
      : "none"};
  border-radius: 8px;
  padding: ${props =>
    props.status === "cancelled" || props.status === "postponed" ? "10px" : ""};
  margin-inline: ${props =>
    props.status === "cancelled" || props.status === "postponed" ? "-8px" : ""};
`

export const DateContainer = styled.div`
  background-color: #fa4616;
  width: 114px;
  height: 104px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 8px 6px;
  gap: 1px;
  margin-top: 0px;

  @media (max-width: 768px) {
    width: 72px;
    height: 68px;
  }
`

export const DateContainerMobile = styled.div`
  background-color: #fa4616;
  width: 114px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px;
  gap: 1px;
  margin-top: 0px;
  margin-bottom: 16px;
`

export const Day = styled.p`
  text-align: center;
  padding: 8px 5px 2px;
  gap: 10px;
  width: 88px;
  height: 49px;
  background: #ffffff;
  border-radius: 5px;
  color: #000033;
  font-weight: 700;
  font-size: 1.4em;

  @media (max-width: 768px) {
    width: 50px;
    height: 32px;
    font-size: 1.1em;
    padding-top: 0px;
  }
`

export const DayMobile = styled.div`
  text-align: center;
  padding: 0px 8px 2px;
  width: 40px;
  height: 22px;
  background: #ffffff;
  border-radius: 4px;
  color: #000033;
  font-weight: 700;
  font-size: 1.125em;
  line-height: 24px;
  white-space: nowrap;
`

export const Date = styled.p`
  font-weight: 700;
  font-size: 1.4em;
  color: #fff;
  white-space: nowrap;
  margin-bottom: 2px;
  margin-left: 4px;

  @media (max-width: 768px) {
    font-size: 1.125em;
    line-height: 24px;
    padding-left: 3px;
  }
`

export const NameContainer = styled.div`
  font-weight: 500;
  font-size: 1.5em;
  line-height: 32px;
  color: #ffffff;
  padding-top: 15px;
  margin-top: 0px;
  margin-left: 9px;

  @media (max-width: 768px) {
    min-width: 50px;
    font-size: 1.2em;
    line-height: 30px;
    padding-top: 3px;
    margin-left: 0px;
  }
`

export const MobileNameContainer = styled.div`
  font-weight: 500;
  font-size: 2em;
  line-height: 40px;
  color: #ffffff;
  margin-top: 0px;
  padding-inline: 0px;
`

export const EventDetailButton = styled(Link)`
  font-weight: 700;
  font-size: 1.5em;
  line-height: 34px;
  align-items: center;
  text-align: center;
  color: #ffffff;
  border-bottom: 1px solid #fe5000;
  margin-left: 15px;
  margin-top: 10px;
  max-width: 120px;
  margin-inline: auto;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ButtonsContainer = styled.div`
  min-width: 160px;
  max-width: 160px;
  margin-top: 0px;
  width: 20%;
  display: flex;
  flex-direction: column;
  padding-top: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ArrowRight = styled.img`
  vertical-align: middle;
  margin-top: 0px;
  width: 10px;

  @media (min-width: 768px) {
    display: none;
  }
`

export const EventDateAndName = styled.div`
  width: ${props => (props.isMainEvent ? "70%" : "55%")};
  margin-top: 0px;
  margin-inline: 0px;

  @media (max-width: 768px) {
    width: ${props => (props.status === "published" ? "95%" : "70%")};
  }
`

export const DateAndName = styled.div`
  width: ${props => (props.isMainEvent ? "70%" : "55%")};
  margin-top: 0px;
  margin-inline: 0px;

  @media (max-width: 768px) {
    width: ${props => (props.status === "published" ? "95%" : "70%")};
    margin: 9px;
  }
`

export const EventColWrappper = styled.div`
  width: ${props => (props.isMainEvent ? "70%" : "55%")};
  margin-top: 0px;
  margin-inline: 0px;

  @media (max-width: 768px) {
    width: ${props => (props.status !== "published" ? "95%" : "70%")};
    margin: 9px;
  }
`

export const Ribbon = styled.img`
  width: ${props => (props.status === "cancelled" ? "85px" : "89px")};
  height: 89px;
  margin: ${props => (props.status === "cancelled" ? "-3px" : "-4px")};
  position: absolute;
  top: 0;
  right: 0;

  @media (min-width: 768px) {
    display: none;
  }
`
export const EventName = styled.p`
  font-size: ${props => (props.isEvent ? "32px" : "24px")};
  line-height: 32px;
  font-family: ${props => (props.isEvent ? "Barlow Condensed" : "Roboto")};
  margin-top: ${props => (props.isEvent ? "0" : "5px")};
  font-weight: 700;
`
export const EventDetail = styled.p`
  font-weight: 500;
  font-size: ${props => (props.isEvent ? "16px" : "24px")};
  line-height: ${props => (props.isEvent ? "24px" : "32px")};
  color: ${props => (props.isEvent ? "#eaeaea" : "#fff")};
  opacity: ${props => (props.isEvent ? 0.8 : 1)};
  margin-top: 10px;
  font-family: Roboto;
`

export const EventMobileDetail = styled.p`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: #b7b7bb;
  padding-top: 13px;
  font-family: Roboto;
`
